module.exports = __webpack_public_path__ + "img/background3.a29828cc.png";